import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import {
  ChatFilter,
  BidderMessage,
  ClerkMessage,
  PinnedMessage,
  ChatTitleContainer,
  MessageTabs, PreviousDecision,
} from 'components/project/ClerkScreen';
import { useStores } from 'hooks';

import { ScrollToBottom } from './ScrollToBottom';
import {
  Container,
  MessagesContainer,
  Messages,
  BidActivityContainer,
} from './Styles';


const Chat = ({
  handleShowBidActivity,
  showBidActivity,
  auctionLog,
  title,
  subTitle,
  indvMessageRef,
  setIndvMessageElFocus,
  laneMessageRef,
  setLaneMessageElFocus,
  pinMessageRef,
  setPinMessageElFocus,
}) => {
  const {
    AuctionStore: { auctionLaneId },
    BidStore: { auction },
    MessageStore: {
      directMessageLog,
      handleSetDirectMessageUser,
      handleSetFilteredMessageData,
      messaging,
    },
    UIStore: {
      // handleChatFontSize,
      handleStorageFontSize,
      handleMonitorChatOnly,
      handleSendDirectMessage,
      handleSendLaneMessage,
      handleSetLanePinMessage,
    },
  } = useStores();

  //const chatFontSize = window.localStorage.getItem('chatFontSize');
  const {
    filteredMessageData,
    itemNumber,
    sendToMemberName,
    sendToUserId,
    sendToUserName,
  } = messaging;

  const allowScroll = true;
  const hasMessages = filteredMessageData?.length > 0 || false;

  const directMessageLogAsString = JSON.stringify(directMessageLog);
  useEffect(() => {
    handleSetFilteredMessageData(directMessageLog);
    return () => null;
  }, [auctionLaneId, directMessageLog, directMessageLogAsString, handleSetFilteredMessageData]);

  const handleReplyTo = (replyToName, replyToId, itemNum, memberName) => handleSetDirectMessageUser(replyToName, replyToId, itemNum, memberName);
  const onClearReplyTo = () => handleSetDirectMessageUser(null, null, null, null);
  const onSendLaneMessage = (message) => handleSendLaneMessage(message);
  const onSendMessage = (message) => handleSendDirectMessage(sendToUserName, sendToUserId, message, itemNumber);

  return (
    <Container monitorChatOnly={auction.monitorChatOnly}>
      <ChatTitleContainer
        title={title}
        subTitle={subTitle}
        avatarUrl={`${process.env.PUBLIC_URL}/favicon.ico`}
        onShowBidActivity={handleShowBidActivity}
        showBidActivity={showBidActivity}
        onMonitorChatOnly={handleMonitorChatOnly}
        monitorChatOnly={auction.monitorChatOnly}
        onChatFontSize={handleStorageFontSize}
        chatFontSize={auction.chatFontSize}
      />
      {showBidActivity ? (
        <BidActivityContainer>
          {auctionLog.reverse().map((value, index) => (
            <div key={index}>{value}</div>
          ))}
        </BidActivityContainer>
      ) : (
        <>
          <ChatFilter
            laneId={auctionLaneId}
          />
          <PinnedMessage />
          <MessagesContainer>
            <Messages>
              {filteredMessageData?.map((message) => (message.type === 'MessageFromClient' ? (
                <BidderMessage
                  key={message.id}
                  itemNumber={message.itemNumber}
                  user={message.memberName}
                  timestamp={message.timestamp}
                  account={message.account}
                  handleMetaDataClick={() => null}
                  isSeller={message.isSeller}
                  onReplyClick={() => {
                    handleReplyTo(
                      message.member,
                      message.account,
                      message.itemNumber,
                      message.memberName,
                    );
                    setIndvMessageElFocus();
                  }}
                  zoomLevel={auction.zoomLevel}
                  chatFontSize={auction.chatFontSize}
                >
                  {message.content}
                </BidderMessage>
              ) : (
                <ClerkMessage
                  key={message.id}
                  itemNumber={message.itemNumber}
                  user={message.memberName}
                  timestamp={message.timestamp}
                  account={message.account}
                  handleMetaDataClick={() => null}
                  avatarUrl={`${process.env.PUBLIC_URL}/favicon.ico`}
                  zoomLevel={auction.zoomLevel}
                  chatFontSize={auction.chatFontSize}
                >
                  {message.content}
                </ClerkMessage>
              ))
                )}
              {hasMessages && allowScroll && <ScrollToBottom />}
            </Messages>
          </MessagesContainer>
          <MessageTabs
            key={`${sendToUserId}_${sendToUserName}_${itemNumber}`}
            replyToId={sendToUserId}
            replyToName={sendToUserName}
            replyToMemberName={sendToMemberName}
            itemNumber={itemNumber}
            handleClearReplyTo={onClearReplyTo}
            handleSendMessage={onSendMessage}
            handleSendLaneMessage={onSendLaneMessage}
            handleSendPinMessage={handleSetLanePinMessage}
            indvMessageRef={indvMessageRef}
            setIndvMessageElFocus={setIndvMessageElFocus}
            laneMessageRef={laneMessageRef}
            setLaneMessageElFocus={setLaneMessageElFocus}
            pinMessageRef={pinMessageRef}
            setPinMessageElFocus={setPinMessageElFocus}
          />
        </>
      )}

      <PreviousDecision small />
    </Container>
  );
};

Chat.propTypes = {
  auctionLog: PropTypes.object,
  handleShowBidActivity: PropTypes.func,
  indvMessageRef: PropTypes.object.isRequired,
  laneMessageRef: PropTypes.object.isRequired,
  pinMessageRef: PropTypes.object.isRequired,
  setIndvMessageElFocus: PropTypes.func.isRequired,
  setLaneMessageElFocus: PropTypes.func.isRequired,
  setPinMessageElFocus: PropTypes.func.isRequired,
  showBidActivity: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

Chat.defaultProps = {
  auctionLog: [],
  handleShowBidActivity: () => null,
  showBidActivity: false,
  subTitle: '',
  title: '',
};

export default observer(Chat);
